const DEFAULT_STATE = {
  id: null,
  items: [],
  page: 1,
  limit: 10,
  total: null,
  statistics: null,
  formData: null,
  loading: false,
  search: null,
  dateRange: null,
  statuses: null,
  sort: {},

  chronologySort: {
    sort_by: 'time',
    sort_direction: 'desc',
  },

  actionLoading: false,
  currentPaymentLink: null,
  _requestVersion: 0,
}

export default {
  ...DEFAULT_STATE,
}
